import script from "./ScreenDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./ScreenDescription.vue?vue&type=script&setup=true&lang=js"

import "./ScreenDescription.vue?vue&type=style&index=0&id=723474d7&lang=css"

const __exports__ = script;

export default __exports__